
import { showFormatedDate, showFormattedTime, showFormatedDateandTime } from '../../../../../actions/utilAction';
import classNames from 'classnames';
import { renderTextArea, renderTextField, renderCheckBox, renderTimePicker, renderCustomRadioButtons } from '../../../../../components/reduxFields';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';

import { connect } from 'react-redux';
// import PatientInfo from '../../../patient_info';
import React from 'react';
import history from '../../../../../history';
import moment from 'moment';
import SignatureModal from './patient_signature_modal';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { getPatientSingleEncounter, saveEncounterSigns, savePatientEncounter } from '../actions';
import { getGeoLocation } from '../../../../AppConfig/actions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSign: false,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      appointmentId: props.match.params.apptId,
      encounterId: props.match.params.encId,
      Signee: [],
      patient_id: null,
      staffID: null,      
      TypeOfObservation: null,       
      ProgressTowardsGoals: null, 
      isDataCollectionEnabledForAgency : false,
      patientSessionNotesSkillsAcquisitionDataArr: [],
      patientSessionNotesBehaviorReductionDataArr: [],
      renderingProviderName: '',
      timeDifference: 0.0,
      claimRenderingProvider: ''
    };
    this.changeIsTypeOfObservation = this.changeIsTypeOfObservation.bind(this);
    this.changeIsProgressTowardsGoals = this.changeIsProgressTowardsGoals.bind(this);
  }
  componentWillMount() {
    let searchObj = {
      'apptId': this.state.appointmentId,
      'encounterId': this.state.encounterId,
    };
    this.props.getPatientSingleEncounter(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && nextProps.singleEncounter !== this.props.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffIds = [];
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffIds.push(staff.staffId);
          staffNames.push(staff.staffName);
        });
        let staffID = staffIds && staffIds.length ? staffIds[0] : null;

        let renderingProviderIds = [];
        let renderingProviderNames = [];
        let signatureRenderingProviders = [];      

        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
          renderingProviderIds.push(staff.renderingProviderId);
          signatureRenderingProviders.push({ 'id': staff.renderingProviderId, 'value': staff.renderingProviderName });
        });
        
        let patientSessionNotesSkillsAcquisitionData = [];
        if (appointmentData.patientSessionNotesSkillsAcquisitionData && appointmentData.patientSessionNotesSkillsAcquisitionData.length) {          
          appointmentData.patientSessionNotesSkillsAcquisitionData.forEach((obj, index) => {
            patientSessionNotesSkillsAcquisitionData.push({
              'Id': obj.targetId,
              'programName': obj.programName,
              'targetName': obj.targetName,
              'targetData': obj.targetData,
            });
          });
          this.setState({
            patientSessionNotesSkillsAcquisitionDataArr: patientSessionNotesSkillsAcquisitionData,
          });                    
        }
        let patientBehaviorReductionData = [];
        if (appointmentData.patientBehaviorReductionData && appointmentData.patientBehaviorReductionData.length) {          
          appointmentData.patientBehaviorReductionData.forEach((obj, index) => {
            patientBehaviorReductionData.push({
              'Id': obj.behaviorsReductionId,
              'behaviorName': obj.behaviorName,
              'recordingTypeName': obj.recordingTypeName,
              'behaviorData': obj.behaviorData,
            });
          });
          this.setState({
            patientSessionNotesBehaviorReductionDataArr: patientBehaviorReductionData,
          });                    
        }
        
        this.setState({
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          patient_id: appointmentData.patientID,
          staffID: staffID,          
          isDataCollectionEnabledForAgency: appointmentData.isDataCollectionEnabledForAgency,
          timeDifference: appointmentData.timeDifference,                 
          claimRenderingProvider: appointmentData.claimRenderingProvider,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj= {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                //Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            } 
          });
        }
        let signeeArray = [];
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          RenderingProviderSign : renderingProviderSignObj,
        });
        if (!(clientSignObj && clientSignObj.Bytes)) {
          // signeeArray.push({ id: 1, value: 'Client' });
        }
        if (!(guardianSignObj && guardianSignObj.Bytes)) {
          signeeArray.push({ id: 2, value: 'Guardian' });
        }
        this.setState({ Signee: signeeArray });
      }
    }

    if(nextProps.TypeOfObservation && nextProps.TypeOfObservation !== this.props.TypeOfObservation){
    //  if(this.props.match.params.encId > 0){
      this.setState({TypeOfObservation: nextProps.TypeOfObservation || 0 },()=>{this.changeIsTypeOfObservation(null,nextProps.TypeOfObservation || 0)});      
     }

    if(nextProps.ProgressTowardsGoals && nextProps.ProgressTowardsGoals !== this.props.ProgressTowardsGoals){
    //  if(this.props.match.params.encId > 0){
      this.setState({ProgressTowardsGoals: nextProps.ProgressTowardsGoals || 0 },()=>{this.changeIsProgressTowardsGoals(null,nextProps.ProgressTowardsGoals || 0)});      
     }   
  }

  changeIsTypeOfObservation = (e, value) => {    
    this.setState({ TypeOfObservation: parseInt(value || 0, 10)});
  };

  changeIsProgressTowardsGoals = (e, value) => {    
    this.setState({ ProgressTowardsGoals: parseInt(value || 0, 10)});
  };

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <TableRow key={index}>
              <TableRowColumn width="30%">{diagnosis.icdCode}</TableRowColumn>
              <TableRowColumn width="70%">{diagnosis.description ? diagnosis.description : '-'}</TableRowColumn>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </TableRow>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <TableRow key={index}>
            <TableRowColumn>{cpt.serviceCode ? cpt.serviceCode : '-'}</TableRowColumn>
            <TableRowColumn>{cpt.description ? cpt.description : '-'}</TableRowColumn>
          </TableRow>
        );
      });
    }
  }

  handleBackClick = () => {
    history.push(`/my-appointment/${this.props.singleEncounter.patientID}`);
  };

  handleOpenSign= () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };

  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    let signeeArray = this.state.Signee;
    switch (formProps.Signee) {
    case 1:
      data.Name = formProps.ClientName;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ ClientSign: data, Signee: signeeArray.splice(0, 1) });
      this.saveEncounterSigns(0, null, data, null);
      break;
    case 2:
      data.Name = formProps.GuardianName;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ GuardianSign: data, Signee: signeeArray.splice(1, 1) });
      this.saveEncounterSigns(0, null, null, data);
      break;
    default:
      break;
    }
  };

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  renderSessionNotesSkillsAcquisition() {
    if (this.state.patientSessionNotesSkillsAcquisitionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesSkillsAcquisitionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.programName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.targetName}</TableRowColumn>
          <TableRowColumn width="20%">{obj.targetData}</TableRowColumn>          
        </TableRow>
      );
    });
  }

  renderSessionNotesBehaviorReduction() {
    if (this.state.patientSessionNotesBehaviorReductionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesBehaviorReductionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.behaviorName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.recordingTypeName}</TableRowColumn>
          <TableRowColumn width="20%">{obj.behaviorData}</TableRowColumn>          
        </TableRow>
      );
    });
  }

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {/* <PatientInfo patientId={this.state.patientid} /> */}
        <div className="clearfix"></div>
        {this.state.openSign ?
          <SignatureModal Signee={this.state.Signee} clientName={this.props.singleEncounter ? this.props.singleEncounter.patientName : ''} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <RaisedButton className="soapmodal_btn mt-20" label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p> */}
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p> */}
                      <p>
                        <b>Supervising Clinician Name :</b> <span>{this.state.renderingProviderName ? this.state.renderingProviderName : '-'}</span>
                      </p> 
                      <p>
                      <b>Session Duration (In Hrs):</b> <span>{this.state.timeDifference && this.state.timeDifference > 0 ? parseFloat((this.state.timeDifference/60).toFixed(2)) : 0.0}</span>
                      </p>
                      <p>
                        <b>Rendering Provider:</b><span>{this.state.claimRenderingProvider ? this.state.claimRenderingProvider : '-'}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Subjective</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Who was present in session?</h5><span style={{ color: 'red'}}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorTechnician"
                    label="Behavior Technician"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Parent"
                    label="Parent"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MidLevelSupervisor"
                    label="Mid-Level Supervisor"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BCBA"
                    label="BCBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Other"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOther &&
                  (<div className='col-sm-4'>
                  <Field
                    name="OtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20">
                    <h5>Type of Observation :</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                  <Field name="TypeOfObservation"
                    options={[{ id: 1, value: 'In-Person' }, { id: 2, value: 'Telehealth' }]}
                    selectedValue={this.state.TypeOfObservation}
                    onChange={this.changeIsTypeOfObservation}
                    disabled={true}
                    component={renderCustomRadioButtons} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>How did people present participate</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. Behavior technician conducted 1:1 direct therapy with the client. The parent assisted with redirection as needed. The BCBA conducted supervision)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="PeoplePresentParticipate"
                    type="text"
                    fullWidth={true}
                    //label="How did people present participate (i.e. Behavior technician conducted 1:1 direct therapy with the client. The parent assisted with redirection as needed. The BCBA conducted supervision)"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Setting Event(s) Reported</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. Client fell asleep at 12pm and woke up at 5am)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="SettingEventReported"
                    type="text"
                    fullWidth={true}
                   // label="Setting Event(s) Reported (i.e. Client fell asleep at 12pm and woke up at 5am)" 
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Atypical Behaviors Reported</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e, The BCBA noted atypical behavior, client was eloping during session and running toward the bedroom)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="AtypicalBehaviorsReported"
                    type="text"
                    fullWidth={true}
                    //label="Atypical Behaviors Reported (i.e, The BCBA noted atypical behavior, client was eloping during session and running toward the bedroom)"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Client Response to Significant Others</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. The client had delayed engagement with people present and required prompting to attend activities throughout the session)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="ClientResponseToSignificantOthers"
                    type="text"
                    fullWidth={true}
                    //label="Client Response to Significant Others (i.e. The client had delayed engagement with people present and required prompting to attend activities throughout the session)"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Objective</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              {this.state.isDataCollectionEnabledForAgency && <div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3>Skill Acquisition Data :</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Program Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Target Name</TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesSkillsAcquisition()}
                  </TableBody>
                </Table>
              </div>

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3>Behavior Reduction Data :</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-10 mb-40">
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Behavior Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Recording Type </TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesBehaviorReduction()}
                  </TableBody>
                </Table>
              </div>
            </div> }
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Goals for Session</h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BuildRapport"
                    label="Build rapport with client ('pairing') with established reinforcers"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillAcquisitionGoals"
                    label="Work on skill acquisition goals"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GeneralizationOfSkillsOrBehaviors"
                    label="Work on generalization of skills or behaviors"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MaintenanceGoals"
                    label="Work on maintenance goals"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DecreasingMaladaptiveBehaviors"
                    label="Work on decreasing maladaptive behaviors"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {/* <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherGoalsForSession"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherGoalsForSession &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherGoalsForSessionNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)} */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Domains Addressed</h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Behavior"
                    label="Behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Communication"
                    label="Communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExecutiveFunctioning"
                    label="Executive Functioning"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkills"
                    label="Social Skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AdaptiveSkills"
                    label="Adaptive Skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CommunityOrSafetySkills"
                    label="Community / Safety Skills"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                {/* <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherDomainsAddressed"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherDomainsAddressed &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherDomainsAddressedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)} */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Evidence-Based Practices (Techniques) Utilized or Discussed </h5><span style={{ color: 'red' }}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AntecedentBasedIntervention"
                    label="Antecedent Based Intervention (ABI)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifferentialReinforcement"
                    label="Differential Reinforcement (DRO/DRA/DRI/DRL)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DiscreteTrialTeaching"
                    label="Discrete Trial Teaching (DTT)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Extinction"
                    label="Extinction"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FunctionalCommunicationTraining"
                    label="Functional Communication Training (FCT)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Modeling"
                    label="Modeling"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IncidentalTeaching"
                    label="Incidental Teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PivotalResponseTraining"
                    label="Pivotal Response Training (PRT)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Prompting"
                    label="Prompting"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ResponseInterruptionAndRedirection"
                    label="Response Interruption and Redirection (RIRD)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkillsTraining"
                    label="Social Skills Training"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TimeDelay"
                    label="Time Delay"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Shaping"
                    label="Shaping"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VisualSupports"
                    label="Visual Supports"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>               
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherEvidenceBasedPractices"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherEvidenceBasedPractices &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherEvidenceBasedPracticesNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
            
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Assessment</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>DSM-5 Deficits to Remediate: Restricted Patterns of Behavior</h5><span style={{ color: 'red' }}>*</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Motorstereotypies"
                    label="Motor stereotypies"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Stereotypieswithobjects"
                    label="Stereotypies with objects (lining up toys/flipping objects/etc)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EcholaliaAndIdiosyncraticSpeech"
                    label="Echolalia and idiosyncratic speech"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExtremeDistressAtSmallChange"
                    label="Extreme distress at small change"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifficultiesWithTransition"
                    label="Difficulties with transition (needing to take the same route/or eat the same food)"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RigidGreetingRituals"
                    label="Rigid greeting rituals"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrongAttachmentsToPreoccupation"
                    label="Strong attachments to/or preoccupation with/unusual objects"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExcessivelyCircumscribedOrPerseverativeInterests"
                    label="Excessively circumscribed or perseverative interests"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ApparentIndifferenceToPainOrTemperature"
                    label="Apparent indifference to pain or temperature"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AdverseResponseToSpecificSights"
                    label="Adverse response to specific sights/sounds/or textures"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VisualFascinationWithLightsOrMovement"
                    label="Visual fascination with lights or movement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherRestrictedPatternsOfBehavior"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherRestrictedPatternsOfBehavior &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherRestrictedPatternsOfBehaviorNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>DSM-5 Deficits to Remediate: Social Communication / Interaction</h5><span style={{ color: 'red' }}>*</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SharingOfInterests"
                    label="Deficits related to sharing of interests/emotions/or affect"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RespondingToSocialInteractions"
                    label="Deficits related to responding to social interactions/including increasing listening responses and verbal communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InitiatingSocialInteractions"
                    label="Deficits related to initiating social interactions/including increasing verbal communication and intelligible speech"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BackAndForthConversations"
                    label="Deficits related to back and forth conversations"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialApproach"
                    label="Deficits related to social approach"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="NonverbalCommunication"
                    label="Deficits related to nonverbal communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IntegratingNonverbalAndVerbalCommunication"
                    label="Deficits related to integrating nonverbal and verbal communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EyeContactAndBodyLanguage"
                    label="Deficits related to eye contact and body language"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FacialExpression"
                    label="Deficits related to facial expression"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="UnderstandingAndUseOfGestures"
                    label="Deficits related to understanding and use of gestures"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SharingImaginativePlay"
                    label="Deficits related to sharing imaginative play"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MakingFriends"
                    label="Deficits related to making friends"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IncreasingInterestInPeer"
                    label="Deficits related to increasing interest in peer"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherSocialCommunication"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherSocialCommunication &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherSocialCommunicationNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Narrative Summary</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(Write a general summary of the session which includes activities conducted for specific skill acquisition and/or behavior reduction targets)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="NarrativeSummary"
                    type="text"
                    fullWidth={true}
                    //label="Narrative Summary (Write a general summary of the session which includes activities conducted for specific skill acquisition and/or behavior reduction targets)"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>Barriers to Treatment</h5><span style={{ color: 'red' }}>*</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Inattentiveness"
                    label="Inattentiveness"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hyperactivity"
                    label="Hyperactivity"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HighRateOfMaladaptiveBehaviors"
                    label="High rate of maladaptive behaviors"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ScrollingResponses"
                    label="Scrolling responses"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RatioStrain"
                    label="Ratio strain"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReinforcerDependent"
                    label="Reinforcer dependent"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PromptDependence"
                    label="Prompt dependence"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HighRateOfSelfStimulatoryBehavior"
                    label="High rate of self-stimulatory behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MotivationWeakenedByResponseRequirement"
                    label="Motivation weakened by response requirement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SensoryDefensiveness"
                    label="Sensory defensiveness"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObsessiveCompulsiveBehavior"
                    label="Obsessive-compulsive behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                        
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="OtherBarriersToTreatment"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBarriersToTreatment &&
                (<div className='col-sm-6'>
                  <Field
                    name="OtherBarriersToTreatmentNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20">
                    <h5>Progress Towards Goals and Outcome of Treatment :</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                  <Field name="ProgressTowardsGoals"
                     options={[{ id: 1, value: 'Exceeding - The client is making exceptional progress towards mastering skill acquisition treatment goals or objectives and/or showing a decrease in maladaptive behaviors.' }, 
                     { id: 2, value: 'As Expected - The client is making progress as expected towards mastering skill acquisition treatment goals or objectives and/or showing a decrease in maladaptive behaviors.' }, 
                     { id: 3, value: 'Delayed - The client is making delayed progress towards mastering skill acquisition treatment goals or objectives and/or showing an increase in maladaptive behaviors due to barriers to treatment.' }]}
                    selectedValue={this.state.ProgressTowardsGoals}
                    onChange={this.changeIsProgressTowardsGoals}
                    disabled={true}
                    component={renderCustomRadioButtons} />
                </div>
              </div>      


              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Plan</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>What are the next steps?</h5><span style={{ color: 'red' }}>*</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="ContinueWithProgramming"
                    label="Continue with programming as directed by the clinical team"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="DiscussProgramProgress"
                    label="Discuss program progress with the clinical team"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                                    
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="OtherNextSteps"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherNextSteps &&
                (<div className='col-sm-6'>
                  <Field
                    name="OtherNextStepsNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn>Service Code</TableHeaderColumn>
                      <TableHeaderColumn>Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              {/* {this.props.isSoapRendered && this.state.Signee.length ?
                <div className="row">
                  <div className="col-sm-12 pt20">
                    <RaisedButton className="soapmodal_btn" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  </div>
                </div>
                : ''} */}
                {this.state.GuardianSign.Bytes ?
                  '':
                  <div className="row">
                    <div className="col-sm-12 pt20">
                      <RaisedButton className="soapmodal_btn" label="Add Sign"  primary={true} onTouchTap={this.handleOpenSign} />
                    </div>
                  </div>
                }
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}

            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null
    , encounterDetail = state.patientPortal.encounter_detail && state.patientPortal.encounter_detail.data ? state.patientPortal.encounter_detail.data : null;
  // console.log(encounterDetail);
  if (encounterDetail) {
    // if (encounterDetail.sessionNotes_NE_ABA) {      
    //   initialData['notes'] = encounterDetail.sessionNotes_NE_ABA.notes;      
    // }

    if (encounterDetail.sessionNotes_BT_Default) {
      
         initialData['PeoplePresentParticipate'] = encounterDetail.sessionNotes_BT_Default.peoplePresentParticipate; 
         initialData['SettingEventReported'] = encounterDetail.sessionNotes_BT_Default.settingEventReported; 
         initialData['AtypicalBehaviorsReported'] = encounterDetail.sessionNotes_BT_Default.atypicalBehaviorsReported; 
         initialData['ClientResponseToSignificantOthers'] = encounterDetail.sessionNotes_BT_Default.clientResponseToSignificantOthers; 

         // bT_Default_Subjective
         initialData['BehaviorTechnician'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].behaviorTechnician : null; 
         initialData['Parent'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].parent : null; 
         initialData['MidLevelSupervisor'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].midLevelSupervisor : null;
         initialData['BCBA'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].bcba : null;
         initialData['Other'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].other : null;
         initialData['OtherNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].otherNotes : null;
         initialData['TypeOfObservation'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] ? (encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 1 ? 1 : (encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 2 ? 2 : 0)) : 0,

         // BT_Default_Objective
         initialData['BuildRapport'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].buildRapport : null;
         initialData['SkillAcquisitionGoals'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].skillAcquisitionGoals : null;
         initialData['GeneralizationOfSkillsOrBehaviors'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].generalizationOfSkillsOrBehaviors : null;
         initialData['MaintenanceGoals'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].maintenanceGoals : null;
         initialData['DecreasingMaladaptiveBehaviors'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].decreasingMaladaptiveBehaviors : null;
         //initialData['OtherGoalsForSession'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherGoalsForSession; 
         //initialData['OtherGoalsForSessionNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherGoalsForSessionNotes; 

         initialData['Behavior'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].behavior : null;
         initialData['Communication'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].communication : null; 
         initialData['ExecutiveFunctioning'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].executiveFunctioning : null;
         initialData['SocialSkills'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].socialSkills : null;
         initialData['AdaptiveSkills'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].adaptiveSkills : null;
         initialData['CommunityOrSafetySkills'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].communityOrSafetySkills : null;
         //initialData['OtherDomainsAddressed'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherDomainsAddressed; 
         //initialData['OtherDomainsAddressedNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherDomainsAddressedNotes; 

         initialData['AntecedentBasedIntervention'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].antecedentBasedIntervention : null; 
         initialData['DifferentialReinforcement'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].differentialReinforcement : null;
         initialData['DiscreteTrialTeaching'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].discreteTrialTeaching : null;
         initialData['Extinction'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].extinction : null;
         initialData['FunctionalCommunicationTraining'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].functionalCommunicationTraining : null;
         initialData['Modeling'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].modeling : null;
         initialData['IncidentalTeaching'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].incidentalTeaching : null;
         initialData['PivotalResponseTraining'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].pivotalResponseTraining : null; 
         initialData['Prompting'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].prompting : null;
         initialData['Reinforcement'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].reinforcement : null; 
         initialData['ResponseInterruptionAndRedirection'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].responseInterruptionAndRedirection : null;
         initialData['SocialSkillsTraining'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].socialSkillsTraining : null;
         initialData['TaskAnalysis'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].taskAnalysis : null;
         initialData['TimeDelay'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].timeDelay : null;
         initialData['Shaping'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].shaping : null;
         initialData['VisualSupports'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].visualSupports : null;
         initialData['OtherEvidenceBasedPractices'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherEvidenceBasedPractices : null;
         initialData['OtherEvidenceBasedPracticesNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Objective[0].otherEvidenceBasedPracticesNotes : null;

         // BT_Default_Assessment
         initialData['Motorstereotypies'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].motorstereotypies : null;
         initialData['Stereotypieswithobjects'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].stereotypieswithobjects : null;
         initialData['EcholaliaAndIdiosyncraticSpeech'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].echolaliaAndIdiosyncraticSpeech : null;
         initialData['ExtremeDistressAtSmallChange'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].extremeDistressAtSmallChange : null;
         initialData['DifficultiesWithTransition'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].difficultiesWithTransition : null;
         initialData['RigidGreetingRituals'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].rigidGreetingRituals : null;
         initialData['StrongAttachmentsToPreoccupation'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].strongAttachmentsToPreoccupation : null;
         initialData['ExcessivelyCircumscribedOrPerseverativeInterests'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].excessivelyCircumscribedOrPerseverativeInterests : null;
         initialData['ApparentIndifferenceToPainOrTemperature'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].apparentIndifferenceToPainOrTemperature : null;
         initialData['AdverseResponseToSpecificSights'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].adverseResponseToSpecificSights : null;
         initialData['VisualFascinationWithLightsOrMovement'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].visualFascinationWithLightsOrMovement : null;
         initialData['OtherRestrictedPatternsOfBehavior'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherRestrictedPatternsOfBehavior : null;
         initialData['OtherRestrictedPatternsOfBehaviorNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherRestrictedPatternsOfBehaviorNotes : null;

         initialData['SharingOfInterests'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].sharingOfInterests : null;
         initialData['RespondingToSocialInteractions'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].respondingToSocialInteractions : null; 
         initialData['InitiatingSocialInteractions'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].initiatingSocialInteractions : null;
         initialData['BackAndForthConversations'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].backAndForthConversations : null;
         initialData['SocialApproach'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].socialApproach : null;
         initialData['NonverbalCommunication'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].nonverbalCommunication : null;
         initialData['IntegratingNonverbalAndVerbalCommunication'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].integratingNonverbalAndVerbalCommunication : null;
         initialData['EyeContactAndBodyLanguage'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].eyeContactAndBodyLanguage : null;
         initialData['FacialExpression'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].facialExpression : null;
         initialData['UnderstandingAndUseOfGestures'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].understandingAndUseOfGestures : null;
         initialData['SharingImaginativePlay'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].sharingImaginativePlay : null;
         initialData['MakingFriends'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].makingFriends : null;
         initialData['IncreasingInterestInPeer'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].increasingInterestInPeer : null;
         initialData['OtherSocialCommunication'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherSocialCommunication : null;
         initialData['OtherSocialCommunicationNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherSocialCommunicationNotes : null;


         initialData['NarrativeSummary'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].narrativeSummary : null;
         initialData['Inattentiveness'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].inattentiveness : null;
         initialData['Hyperactivity'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].hyperactivity : null;
         initialData['HighRateOfMaladaptiveBehaviors'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].highRateOfMaladaptiveBehaviors : null;
         initialData['ScrollingResponses'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].scrollingResponses : null;
         initialData['RatioStrain'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].ratioStrain : null;
         initialData['ReinforcerDependent'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].reinforcerDependent : null;
         initialData['PromptDependence'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].promptDependence : null;
         initialData['HighRateOfSelfStimulatoryBehavior'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].highRateOfSelfStimulatoryBehavior : null;
         initialData['MotivationWeakenedByResponseRequirement'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].motivationWeakenedByResponseRequirement : null;
         initialData['SensoryDefensiveness'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].sensoryDefensiveness : null;
         initialData['ObsessiveCompulsiveBehavior'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].obsessiveCompulsiveBehavior : null;
         initialData['OtherBarriersToTreatment'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherBarriersToTreatment : null;
         initialData['OtherBarriersToTreatmentNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].otherBarriersToTreatmentNotes : null;

         //initialData['ProgressTowardsGoals'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 1 ? 1 : (encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 2 ? 2 : 0); 

         // BT_Default_Plan
         initialData['ContinueWithProgramming'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0].continueWithProgramming : null;
         initialData['DiscussProgramProgress'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0].discussProgramProgress : null;
         initialData['OtherNextSteps'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0].otherNextSteps : null;
         initialData['OtherNextStepsNotes'] = encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0] ? encounterDetail.sessionNotes_BT_Default.bT_Default_Plan[0].otherNextStepsNotes : null;
  }

    if (encounterDetail.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = encounterDetail.patientEncounterDiagnosisCodes;
    }
    if (encounterDetail.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = encounterDetail.patientEncounterServiceCodes;
    }

    // if(encounterDetail.appointmentStartDateTime){
    //   let startTimehours = encounterDetail.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = encounterDetail.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours) >= 12 ?
    //     (parseInt(startTimehours) - 12 < 10 ?
    //       `0${parseInt(startTimehours) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours) >= 12 ? (parseInt(endTimehours) - 12 < 10 ? `0${parseInt(endTimehours) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${encounterDetail.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('encounterDetail.............', encounterDetail);

    if (encounterDetail.startDateTime) {
      let startTimehours = encounterDetail.startDateTime.substr(11, 2);
      let endTimehours = encounterDetail.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${encounterDetail.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = encounterDetail.locationName;
    initialData['staffName'] = encounterDetail.staffName;
    initialData['appointmentDate'] = encounterDetail.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = encounterDetail.PatientLocationName;
    initialData['serviceEndTime'] = moment(encounterDetail.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(encounterDetail.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  let isSoapRendered = false;
  if (encounterDetail && encounterDetail.status && encounterDetail.status.toLowerCase() === 'rendered') {
    isSoapRendered = true;
  }

  return {
      selectorOther: selector(state, 'Other'),
      selectorOtherEvidenceBasedPractices: selector(state, 'OtherEvidenceBasedPractices'),
      selectorOtherBarriersToTreatment: selector(state, 'OtherBarriersToTreatment'),
      selectorOtherNextSteps: selector(state, 'OtherNextSteps'),
      selectorOtherGoalsForSession: selector(state, 'OtherGoalsForSession'),
      selectorOtherDomainsAddressed: selector(state, 'OtherDomainsAddressed'),
      selectorOtherRestrictedPatternsOfBehavior: selector(state, 'OtherRestrictedPatternsOfBehavior'),
      selectorOtherSocialCommunication: selector(state, 'OtherSocialCommunication'),

      singleEncounter: encounterDetail,
      isSoapRendered: isSoapRendered,
      initialValues: initialData,    
     
      TypeOfObservation: (encounterDetail && encounterDetail.sessionNotes_BT_Default &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation >= 0 ? ( encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 1 ? 1 : ( encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0] &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 2 ? 2 : 0)) : 0),
      ProgressTowardsGoals: (encounterDetail && encounterDetail.sessionNotes_BT_Default &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals >= 0 ?  encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 1 ? 1 : ( encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 2 ? 2 : ( encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0] &&  encounterDetail.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 3 ? 3 : 0)) : 0),
      latitude: state.appConfig.latitude,
      longitude: state.appConfig.longitude,
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounter, savePatientEncounter, saveEncounterSigns, getGeoLocation })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/patient_sessionNotes_BT_Default.js